var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Skeleton, Text } from '@dixa/lib-shared-habla';
import { countries } from 'country-data-list';
import { useMemo } from 'react';
export const BillingInformation = (props) => {
    var _a;
    const { isLoading } = props, billingInformation = __rest(props, ["isLoading"]);
    const { email, companyName, address1, address2, city, country, name, state, postalCode, vatin, } = billingInformation;
    const lineName = name;
    const lineContact = email;
    const lineAddress = [address1, address2].filter((val) => !!val).join(', ');
    const lineLocation = [city, postalCode].filter((val) => !!val).join(', ');
    const countryName = country ? (_a = countries[country]) === null || _a === void 0 ? void 0 : _a.name : '';
    const lineCountry = [countryName, state].filter((val) => !!val).join(', ');
    const lineCompanyVatin = [companyName, vatin]
        .filter((val) => !!val)
        .join(', ');
    const isEmpty = useMemo(() => {
        return Object.values(billingInformation).every((val) => val === '');
    }, [billingInformation]);
    if (isLoading) {
        return (_jsxs(Box, { children: [_jsx(Skeleton, { height: "15px", width: "100%", maxWidth: "400px", margin: "0 0 100 0" }), _jsx(Skeleton, { height: "15px", width: "100%", maxWidth: "400px", margin: "0 0 300 0" }), _jsx(Skeleton, { height: "15px", width: "100%", maxWidth: "240px", margin: "0 0 100 0" }), _jsx(Skeleton, { height: "15px", width: "100%", maxWidth: "240px", margin: "0 0 100 0" }), _jsx(Skeleton, { height: "15px", width: "100%", maxWidth: "200px", margin: "0 0 300 0" }), _jsx(Skeleton, { height: "16px", width: "100%", maxWidth: "240px" })] }));
    }
    if (isEmpty) {
        return (_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Please edit your billing information..." })));
    }
    return (_jsxs(_Fragment, { children: [(lineName || lineContact) && (_jsxs(Box, Object.assign({ margin: "0 0 200 0" }, { children: [lineName && (_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: lineName }))), lineContact && _jsx(Text.Paragraph, { children: lineContact })] }))), lineAddress && _jsx(Text.Paragraph, { children: lineAddress }), lineLocation && _jsx(Text.Paragraph, { children: lineLocation }), lineCountry && _jsx(Text.Paragraph, { children: lineCountry }), lineCompanyVatin && (_jsx(Box, Object.assign({ padding: "200 0 0 0" }, { children: _jsx(Text.Paragraph, { children: lineCompanyVatin }) })))] }));
};
